const initialState = {
  folderPath: [],
};

export default initialState;
